import { faCircleXmark, faThumbsDown, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { Button, Modal } from 'react-bootstrap';


const ModalSimNao = ({ children, show, handleClose, handleConfirm, exibeBotoes }) => {

    return (

        <Modal show={show} onHide={() => handleClose()}>
            <Modal.Body className='text-center' style={{ fontSize: '15px' }}>
                <div className='alert alert-danger'>
                    {children}
                </div>
            </Modal.Body>
            <Modal.Footer className='justify-content-center'>

                {(exibeBotoes != undefined && !exibeBotoes) ? (
                    <>
                        <Button variant='danger' size='sm' onClick={() => handleClose()}><FontAwesomeIcon icon={faCircleXmark} /> Fechar</Button>

                    </>
                ) : (<>
                    <Button variant='danger' size='sm' onClick={() => handleClose()}><FontAwesomeIcon icon={faThumbsDown} /> Não</Button>
                    <Button variant='primary' size='sm' onClick={() => handleConfirm()}><FontAwesomeIcon icon={faThumbsUp} /> Sim</Button>

                </>)}

            </Modal.Footer>
        </Modal>
    )
}


export default ModalSimNao;